<div class="ui-busy" *ngIf="loader.isLoading()">
  <div class="ui-busy__card">
    <span class="ui-spinner" aria-hidden="true"></span>
    <span>{{ label }}</span>
  </div>
</div>
